/**
 * @enum
 */
export const ChecklistInputFields = Object.freeze({
	Name: 'checklistName',
	Description: 'checklistDescription',
});
/**
 * @enum
 */
export const CheckpointInputFields = Object.freeze({
	Name: 'checkpointName',
	Description: 'checkpointDescription',
	Status: 'checkpointStatus',
	Dropdown: 'checkpointDropdown',
});
